"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var delete_icon_button_component_1 = __importDefault(require("../../common-components/delete-icon-button/delete-icon-button.component"));

var use_modal_toggle_state_hook_1 = __importDefault(require("../../hooks/use-modal-toggle-state.hook"));

var confirmation_modal_component_1 = __importDefault(require("../../common-components/confirmation-modal/confirmation-modal.component"));

var RemoveOptionButton = function RemoveOptionButton(_ref) {
  var removeOption = _ref.removeOption,
      size = _ref.size;

  var _use_modal_toggle_sta = use_modal_toggle_state_hook_1.default(),
      handleOpen = _use_modal_toggle_sta.handleOpen,
      handleClose = _use_modal_toggle_sta.handleClose,
      modalProps = _use_modal_toggle_sta.modalProps;

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(delete_icon_button_component_1.default, {
    onClick: handleOpen,
    size: size
  }), react_1.default.createElement(confirmation_modal_component_1.default, Object.assign({}, modalProps, {
    description: "\u672C\u5F53\u306B\u9078\u629E\u80A2\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F",
    onCancelClick: handleClose,
    onConfirmClick: function onConfirmClick() {
      removeOption();
      handleClose();
    }
  })));
};

exports.default = RemoveOptionButton;